document.addEventListener('DOMContentLoaded', function () {
	const sameAsResidentialCheckbox = document.getElementById('id_same_as_residential');
	const postalAddressFields = document.querySelectorAll('#postalAddressSection input, #postalAddressSection select');

	if (!sameAsResidentialCheckbox) {
		return;
	}

	if (sameAsResidentialCheckbox.checked) {
		setPostalFieldsReadOnly(true);
	}

	sameAsResidentialCheckbox.addEventListener('change', function () {
		if (this.checked) {
			copyResidentialToPostal();
			setPostalFieldsReadOnly(true);
		} else {
			setPostalFieldsReadOnly(false);
		}
	});

	function copyResidentialToPostal() {
		const residentialAddressFields = {
			'residential_address_address_line_1': 'postal_address_address_line_1',
			'residential_address_address_line_2': 'postal_address_address_line_2',
			'residential_address_city': 'postal_address_city',
			'residential_address_state': 'postal_address_state',
			'residential_address_postcode': 'postal_address_postcode'
		};

		for (const [resField, postField] of Object.entries(residentialAddressFields)) {
			const resInput = document.getElementById(`id_${resField}`);
			const postInput = document.getElementById(`id_${postField}`);
			if (resInput && postInput) {
				postInput.value = resInput.value;
			}
		}
	}

	function setPostalFieldsReadOnly(isReadOnly) {
		postalAddressFields.forEach(field => {
			if (field.tagName === 'SELECT') {
				field.disabled = isReadOnly;
			} else {
				field.readOnly = isReadOnly;
			}
		});
	}
});